<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true"
    >
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef" lazy-validation>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm5>
                                <v-text-field
                                        label="用户名"
                                        :rules="rules.required"
                                        v-model="item.username"
                                />
                            </v-flex>

                            <v-flex xs12 sm5>
                                <v-text-field
                                        label="密码"
                                        :rules="rules.password"
                                        v-model="item.password"
                                        persistent-hint
                                        hint="重置密码时填写，不修改密码时留空。"
                                />
                            </v-flex>

                            <v-flex xs12 sm2>
                                <v-select
                                        label="禁用"
                                        v-model="item.disabled"
                                        :items="[{value: true, text:'是'},{value: false, text:'否'}]"
                                        :rules="rules.binary"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="姓名"
                                        required
                                        :rules="rules.required"
                                        v-model="item.name"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="工号"
                                        required
                                        :rules="rules.required"
                                        v-model="item.number"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-menu
                                        ref="refBirthday"
                                        :close-on-content-click="false"
                                        v-model="menuBirthday"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        max-width="290px">
                                    <v-text-field
                                            slot="activator"
                                            v-model="item.birthday"
                                            label="出生日期"
                                            :rules="rules.birthday"
                                            hint="格式YYYY-MM-DD, 如：2018-10-01"
                                            persistent-hint
                                    />
                                    <v-date-picker
                                            v-model="birthday"
                                            locale="zh-cn"
                                            @change="nv => item.birthday= nv"
                                    />
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm2>
                                <v-autocomplete
                                        label="职称"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.tileId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="titleItems"
                                />
                            </v-flex>

                            <v-flex xs12 sm2>
                                <v-autocomplete
                                        label="学位"
                                        clearable
                                        required
                                        :rules="rules.required"
                                        v-model="item.acadDegreeId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="educaItems"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="联系电话"
                                        :rules="rules.phone"
                                        v-model="item.phone"
                                />
                            </v-flex>

                            <v-flex xs12 sm4>
                                <v-text-field
                                        label="电子邮箱"
                                        :rules="rules.email"
                                        v-model="item.email"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <x-dept-roles
                                        label="部门及角色"
                                        v-model="item.deptRoles"
                                        hint="用户的主部门须排在第一。"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field label="备注" v-model="item.note"/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onSave">保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import mixin from '@/mixin'

    import XDeptRoles from './DeptRoles'

    const baseUri = '/api/syst/user';
    const titleUri = '/api/code/title';
    const eduUri = '/api/code/education';

    export default {
        mixins: [mixin.edit(baseUri)],
        components: {XDeptRoles},
        data() {
            return {
                formValid: false,

                item: {},
                freshItem: {
                    "username": null,
                    "name": null,
                    "password": null,
                    "email": null,
                    "number": null,
                    "disabled": null,
                    "deptRoles": [],

                    "birthday": null,
                    "tileId": null,
                    "acadDegreeId": null,
                    "phone": null,

                    "note": null
                },

                menuBirthday: false,
                birthday: null,

                titleItems: [],
                educaItems: [],

                /**
                 * 验证规则
                 */
                rules: {
                    required: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 20) || '长度必须小于20个字符。'
                    ],
                    password: [
                        // 创建新用户时才验证密码
                        v => ((this.dbid && this.dbid.length > 0) || !!v) || '必填项。',
                        v => ((this.dbid && this.dbid.length > 0) ||v && v.length <= 20) || '长度必须小于20个字符。',
                        v => ((this.dbid && this.dbid.length > 0) ||v && /^[^\s]+$/.test(v)) || '密码不能保含空白字符.'
                    ],
                    email: [v => (v && (/^([0-9A-Za-z\-_.]+)@(([0-9a-z]+\.)+[a-z]{2,3})$/ig.test(v))) || '邮箱格式不正确.'],
                    phone: [
                        v => !!v || '必填项。',
                        v =>
                            (
                                v &&
                                (/(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/.test(v))
                            ) || '格式不正确，请输入正确的手机号码，或固定电话号码.'
                    ],
                    binary: [
                        v => (v === true || v === false) || '必填项。'
                    ],
                    normal: [v => (!v || v.length <= 50) || '长度必须小于50个字符。'],
                    birthday: [
                        v => !!v || "必填项。",
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ],
                }
            }
        },

        created() {
            this.axios.all([
                this.axios.get(titleUri, {params: {limit: 65535, disabled: 'F'}}),
                this.axios.get(eduUri, {params: {limit: 65535, disabled: 'F'}}),
            ]).then(
                this.axios.spread(
                    (rspTitle, rspEdu) => {
                        this.titleItems = rspTitle.data.items;
                        this.educaItems = rspEdu.data.items;
                    }
                )
            )
        },

        methods: {
            // mixin 加载数据后调用
            // afterGetData(data) {
            //   //this.parentItems = data.parent ? [data.parent] : []
            // }
        }
    }
</script>
